<ng-container *ngIf="menu.children && menu.children.length > 0">
  <button mat-menu-item [matMenuTriggerFor]="sub_menu_button"
    [disabled]="!menu.enable">
    {{ menu.text }}
  </button>
  <mat-menu #sub_menu_button="matMenu">
    <ng-container *ngFor="let m of menu.children">
      <button *ngIf="m.show && (!m.children || m.children.length === 0)"
        mat-menu-item
        (click)="navigateTo(m.routerLink)"
        [disabled]="!m.enable">
        {{ m.text }}
      </button>

      <app-sub-menu-up-bar2
        *ngIf="m.show && m.children && m.children.length > 0"
        [menu]="m">
      </app-sub-menu-up-bar2>
    </ng-container>
  </mat-menu>
</ng-container>
